export var ReceiveFromNetworkServiceType;
(function (ReceiveFromNetworkServiceType) {
    ReceiveFromNetworkServiceType["ETransfer"] = "ETransfer";
    ReceiveFromNetworkServiceType["EBridge"] = "EBridge";
})(ReceiveFromNetworkServiceType || (ReceiveFromNetworkServiceType = {}));
export var ReceiveType;
(function (ReceiveType) {
    ReceiveType["Portkey"] = "Portkey";
    ReceiveType["ETransfer"] = "ETransfer";
    ReceiveType["EBridge"] = "EBridge";
})(ReceiveType || (ReceiveType = {}));
